import type { GetChatsByFiltersChat } from '../../../queries/chats';

export const ACTIVE_CHAT_STATUS: GetChatsByFiltersChat['status'] = 'ACTIVE';
export const ARCHIVED_CHAT_STATUS: GetChatsByFiltersChat['status'] = 'ARCHIVED';

type OptimisticChat = GetChatsByFiltersChat & {
  __typename: 'Chat';
  account: (NonNullable<GetChatsByFiltersChat['account']> & { __typename: 'Account' }) | null;
};

type OptimisticChatOverrides = Partial<
  Pick<GetChatsByFiltersChat, 'deletedAt' | 'hasUnreadMessages' | 'status' | 'title' | 'updatedAt'>
>;

export function buildOptimisticChat(chat: GetChatsByFiltersChat, overrides: OptimisticChatOverrides): OptimisticChat {
  return {
    ...chat,
    ...overrides,
    updatedAt: overrides.updatedAt ?? new Date().toISOString(),
    __typename: 'Chat',
    account: chat.account ? { ...chat.account, __typename: 'Account' } : null,
  };
}

export function hasMutationErrors(result: { errors?: readonly unknown[] }): boolean {
  return Boolean(result.errors?.length);
}
